import { AbilityBuilder, Ability } from '@casl/ability'

export default function defineAbilityFor(perms) {
    const { can, cannot, rules } = new AbilityBuilder();

    if (perms && typeof perms === 'object') {
      for (var i in perms) {
        if (perms[i]) {
          can(perms[i])
        }
      }
    }

    return Array.isArray(rules) ? rules : []
}